import React from 'react';
import { Heading } from '../../components';
import css from '../../containers/ListingPage/ListingPage.module.css';

import { FaDog as FaDogMedium } from 'react-icons/fa';
import { FaDog as FaDogLarge } from "react-icons/fa6";
import { GiSittingDog } from "react-icons/gi";
import { BiSolidDog } from "react-icons/bi";

const petSizeDisplayData = {
  Dog_use1: {
    name: 'Small (0–7 Kg)',
    icon: <BiSolidDog />,
  },
  Dog_use2: {
    name: 'Medium (7–20 Kg)',
    icon: <FaDogMedium size={18}  />,
  },
  Dog_use3: {
    name: 'Large (20–25 Kg)',
    icon: <FaDogLarge size={20} />,
  },
  Dog_use4: {
    name: 'Extra Large (25 Kg+)',
    icon: <GiSittingDog size={25} />,
  },
};

// Define the desired order
const petSizeOrder = ['Dog_use1', 'Dog_use2', 'Dog_use3', 'Dog_use4'];

const SectionPetSizes = props => {
  const { heading, selectedOptions = [] } = props;
  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  // Sort the options by predefined order
  const sortedOptions = [...selectedOptions].sort(
    (a, b) => petSizeOrder.indexOf(a) - petSizeOrder.indexOf(b)
  );

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.cleaningFacilitiesList}>
        {sortedOptions.map(option => {
          const facility = petSizeDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{facility?.icon}</span>
              <span>{facility?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionPetSizes;
